(function () {
  'use strict';

  var productCache = Object.create(null);

  function updateCartCount(count) {
    document.querySelectorAll('.wudy-cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function fetchCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn) return;

    var label = btn.textContent;
    btn.disabled = true;

    var addPromise = window.WudyAtc
      ? window.WudyAtc.addVariant(variantId, 1)
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        });

    return addPromise
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        if (window.WudyAtc) window.WudyAtc.updateCartCount();
        else fetchCartCount();
        window.setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.disabled = false;
      });
  }

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      });
  }

  function firstAvailableVariant(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function findVariant(product, selected) {
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selected[index];
      });
    });
  }

  function isValueAvailable(product, optionIndex, value, selected) {
    return product.variants.some(function (variant) {
      if (!variant.available) return false;
      if (variant.options[optionIndex] !== value) return false;
      for (var i = 0; i < selected.length; i++) {
        if (i === optionIndex) continue;
        if (selected[i] && variant.options[i] !== selected[i]) return false;
      }
      return true;
    });
  }

  function getOptionValues(product, optionIndex) {
    var values = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[optionIndex];
      if (values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function closePicker(wrap) {
    if (!wrap) return;
    var picker = wrap.querySelector('[data-wudy-card-picker]');
    var toggle = wrap.querySelector('[data-wudy-card-options]');
    wrap.classList.remove('is-open');
    if (picker) {
      picker.hidden = true;
      picker.innerHTML = '';
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllPickers(except) {
    document.querySelectorAll('[data-wpc-actions-wrap].is-open').forEach(function (wrap) {
      if (wrap !== except) closePicker(wrap);
    });
  }

  function updatePickerAddButton(wrap, product, selected) {
    var picker = wrap.querySelector('[data-wudy-card-picker]');
    if (!picker) return;

    var footer = picker.querySelector('[data-wudy-picker-footer]');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'wpc-picker__footer';
      footer.setAttribute('data-wudy-picker-footer', '');
      picker.appendChild(footer);
    }

    footer.innerHTML = '';
    var variant = findVariant(product, selected);

    if (!variant || !variant.available) {
      var sold = document.createElement('span');
      sold.className = 'wpc-picker__sold';
      sold.textContent = 'Unavailable';
      footer.appendChild(sold);
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wpc-picker__atc';
    btn.setAttribute('data-wudy-card-atc', '');
    btn.setAttribute('data-variant-id', variant.id);
    btn.textContent = 'Add to cart';
    footer.appendChild(btn);
  }

  function renderPicker(wrap, product) {
    var picker = wrap.querySelector('[data-wudy-card-picker]');
    if (!picker) return;

    var first = firstAvailableVariant(product);
    var selected = first ? first.options.slice() : product.variants[0].options.slice();

    picker.innerHTML = '';

    product.options.forEach(function (optionName, optionIndex) {
      if (optionName === 'Title' && product.variants.length <= 1) return;

      var group = document.createElement('div');
      group.className = 'wpc-picker__group';
      group.setAttribute('data-option-index', optionIndex);

      var label = document.createElement('span');
      label.className = 'wpc-picker__label';
      label.textContent = optionName;
      group.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'wpc-picker__values';

      getOptionValues(product, optionIndex).forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wpc-picker__value';
        btn.textContent = value;
        if (selected[optionIndex] === value) btn.classList.add('is-selected');
        if (!isValueAvailable(product, optionIndex, value, selected)) {
          btn.classList.add('is-unavailable');
        }

        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;

          selected[optionIndex] = value;
          valuesWrap.querySelectorAll('.wpc-picker__value').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');

          picker.querySelectorAll('.wpc-picker__group').forEach(function (otherGroup) {
            var otherIndex = Number(otherGroup.getAttribute('data-option-index'));
            if (otherIndex === optionIndex) return;
            otherGroup.querySelectorAll('.wpc-picker__value').forEach(function (el) {
              var val = el.textContent;
              el.classList.toggle('is-unavailable', !isValueAvailable(product, otherIndex, val, selected));
            });
          });

          updatePickerAddButton(wrap, product, selected);
        });

        valuesWrap.appendChild(btn);
      });

      group.appendChild(valuesWrap);
      picker.appendChild(group);
    });

    updatePickerAddButton(wrap, product, selected);
  }

  function openPicker(wrap, handle) {
    closeAllPickers(wrap);
    wrap.classList.add('is-open');
    var picker = wrap.querySelector('[data-wudy-card-picker]');
    var toggle = wrap.querySelector('[data-wudy-card-options]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (picker) picker.hidden = false;

    fetchProduct(handle)
      .then(function (product) {
        renderPicker(wrap, product);
      })
      .catch(function () {
        closePicker(wrap);
      });
  }

  document.addEventListener('click', function (event) {
    var optionsBtn = event.target.closest('[data-wudy-card-options]');
    if (optionsBtn) {
      event.preventDefault();
      event.stopPropagation();

      var wrap = optionsBtn.closest('[data-wpc-actions-wrap]');
      if (!wrap) return;

      if (wrap.classList.contains('is-open')) {
        closePicker(wrap);
        return;
      }

      openPicker(wrap, optionsBtn.getAttribute('data-product-handle'));
      return;
    }

    if (!event.target.closest('[data-wpc-actions-wrap]')) {
      closeAllPickers(null);
    }

    var btn = event.target.closest('[data-wudy-card-atc]');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    addToCart(variantId, btn);
  });

  function bindWishlist(scope) {
    if (window.WudyWishlist && typeof window.WudyWishlist.bind === 'function') {
      window.WudyWishlist.bind(scope || document);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindWishlist(document);
  });

  document.addEventListener('wudy:shop-all-hydrated', function (event) {
    bindWishlist(event.target || document);
  });
})();
